import React, { Fragment } from 'react';
import { isNil } from 'lodash';

import PercentageInput from '../../common/percentageInput';
import { DEFAULT_AUTO_TIPS_FEE_PERCENT, DEFAULT_COMMISSION_SPLIT_FEE_PERCENT } from './constants';
import { formatPercentage } from '../../common/Percentage';

const CommissionSplitFees = () => (
  <Fragment>
    <div className="c-heading c-heading--lightgrey c-wrapper u-pv0 u-mb-">
      Auto Payout Settings
    </div>
    <div className="c-wrapper-horizontal u-pb--">
      <div className="layout">
        <div className="layout__item u-mt-">
          <div className="c-label-new">Daily Shop Payout Fee</div>
          <PercentageInput
            className="c-input"
            name="dailyPayrollTipFee"
            parse={val => ((val === '' || isNil(val)) ? null : Number(val))}
            placeholder={formatPercentage(DEFAULT_AUTO_TIPS_FEE_PERCENT, 2)}
            allowEmpty
          />
        </div>
        <div className="layout__item u-mt-">
          <div className="c-label-new">Auto Commission Split Fee</div>
          <PercentageInput
            className="c-input"
            name="commissionSplitsPercentFee"
            parse={val => ((val === '' || isNil(val)) ? null : Number(val))}
            placeholder={formatPercentage(DEFAULT_COMMISSION_SPLIT_FEE_PERCENT, 2)}
            allowEmpty
          />
        </div>
      </div>
    </div>
  </Fragment>
);

export default CommissionSplitFees;
